import { jsx as l, Fragment as n } from "react/jsx-runtime";
import { useEffect as s } from "react";
import { r as i } from "../../index-YbL9dKxh.mjs";
import '../../assets/Overlay.css';const v = "_overlay_itsaf_1", d = {
  overlay: v
};
function p({ appendToElement: r, state: o = "entering" }) {
  (() => {
    if (!document.querySelector("#overlay")) {
      const t = document.createElement("div");
      t.setAttribute("id", "overlay"), t.setAttribute("class", `${d.overlay} overlay`), t.setAttribute("data-state", "entering"), r !== null ? r.append(t) : document.body.appendChild(t);
    }
  })();
  const a = setInterval(() => {
    const e = document.querySelector("#overlay");
    if (e) {
      const t = () => {
        const c = new CustomEvent("scripps:overlay:closed");
        document.dispatchEvent(c), e.setAttribute("data-state", "exiting"), setTimeout(() => {
          e.remove();
        }, 200);
      };
      clearInterval(a), e.addEventListener("click", t);
    }
  });
  return s(() => {
    var e;
    (e = document.querySelector("#overlay")) == null || e.setAttribute("data-state", o);
  }, [o]), i.createPortal(
    /* @__PURE__ */ l(n, {}),
    document.getElementById("overlay")
  );
}
export {
  p as Overlay,
  p as default
};
